import { render, staticRenderFns } from "./BankInternalAccount.vue?vue&type=template&id=6e39720e&scoped=true&"
import script from "./BankInternalAccount.vue?vue&type=script&lang=js&"
export * from "./BankInternalAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e39720e",
  null
  
)

export default component.exports